<template>
	<div class="p-4">
		<div class="warning-box">
			<img src="@/assets/images/iconPack/warning.svg" />
			<span class="mr-2">توجه</span>
			<ul>
				<li>
					لطفا اطلاعات فایل آپلود شده را به درستی وارد کنید. نام فایل بیشتر از ۴۰ کاراکتر نباشد.
				</li>
				<li>آیکون انتخابی برای فایل با فرمت png و بدون بکگراند باشد.</li>
				<li>میتوانید از سایت flaticon.com برای انتخاب آیکون استفاده کنید.</li>
			</ul>
		</div>
		<div class="card">
			<div class="card-body">
				<h5 class="mb-4">اطلاعات فایل</h5>
				<div class="d-flex align-items-center mb-4">
					<span class="ml-2">نام فایل:</span>
					<input v-model="fileName" class="inputs" />
				</div>
				<div class="d-flex align-items-center mb-4">
					<span class="ml-2">نوع فایل:</span>
					<select class="inputs" v-model="fileType">
						<option value="EDU">آموزش</option>
						<option value="ETC">سایر</option>
					</select>
				</div>
				<div class="d-flex align-items-center mb-4">
					<span class="ml-2">انتخاب آیکون:</span>
					<div class="d-flex align-items-center">
						<input
							type="file"
							ref="fileInput"
							accept=".png,.svg,.gif"
							style="display: none"
							@change="handleFileChange"
						/>
						<button class="upload-icons-btn" @click="openFileDialog">
							<img class="iconify" src="@/assets/images/iconPack/upload_noback.svg" />
						</button>
						<div class="mr-3" v-if="selectedIcon">
							<img
								class="preview-icon"
								:src="getFilePreviewURL(selectedIcon)"
								alt="Selected File Preview"
							/>
						</div>
					</div>
				</div>
				<div class="d-flex flex-column">
					<span>توضیحات:</span>
					<textarea v-model="desc" rows="4" cols="50" class="text-area"></textarea>
				</div>
				<div class="upload-box">
					<input type="file" @change="uploadFile" />
					<div class="icon">
						<!-- <span class="iconify" data-icon="ic:outline-file-upload"></span> -->
						<img class="iconify" src="@/assets/images/iconPack/upload.svg" />
					</div>
					<span class="upload-text">آپلود فایل</span>
					<p>فایل مورد نظر خود را در این محل بکشید و رها کنید</p>
				</div>
				<div class="button-container">
					<button :disabled="checkEmpty" @click="postData" class="continue">مرحله بعد</button>
				</div>
			</div>
		</div>
<loading v-if="loading"/>

	</div>
</template>

<script>
import Loading from '../../components/Loading/index.vue';

export default {
	components: {
		Loading
	},
	data() {
		return {
			uploadedImg: null,
			fileName: '',
			desc: null,
			fileType: '',
			selectedIcon: null,
			loading:false
		};
	},
	computed: {
		checkEmpty() {
			if (
				this.uploadedImg === null ||
				this.uploadedImg === '' ||
				this.selectedIcon === null ||
				this.fileName === '' ||
				this.fileType === ''
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		openFileDialog() {
			this.$refs.fileInput.click();
		},
		handleFileChange(event) {
			const file = event.target.files[0];
			if (this.isValidFileType(file)) {
				this.selectedIcon = file;
				// Perform any additional actions with the file
			} else {
				// Reset the selected file and display an error message
				this.selectedIcon = null;
				alert('Invalid file format. Please choose a PNG, SVG, or GIF file.');
			}
		},
		getFilePreviewURL(file) {
			return window.URL.createObjectURL(file);
		},
		isValidFileType(file) {
			const allowedTypes = ['image/png', 'image/svg+xml', 'image/gif'];
			return allowedTypes.includes(file.type);
		},
		async postData() {
			this.loading = true
			const formData = new FormData();
			formData.append('file', this.uploadedImg);
			formData.append('name', this.fileName);
			formData.append('description', this.desc);
			formData.append('icon', this.selectedIcon);
			formData.append('type', this.fileType);
			formData.append('project', this.$STORE.state.userConfig.setProjectId);
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.UPLOAD_FILE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				formData,
				{
					'Content-Type': 'multipart/form-data',
				},
			);
			if (res.status === 201) {
				this.loading = false
				this.$router.push({ name: 'fileList' });
			}
		},
		async uploadFile(e) {
			// (e.target.files)
			// let fd = new FormData();
			// fd.append('file', e.target.files[0]);
			this.uploadedImg = e.target.files[0];
			this.$notify({
				group: 'tc',
				type: 'success',
				text: 'فایل با موفقیت بارگزاری شد',
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.warning-box {
	padding: 16px;
	color: #664d03;
	background: #fff3cd;
	border-radius: 8px;
	margin-bottom: 16px;
	li {
		margin: 0px 34px;
		list-style: disc;
	}
}
.card {
	border: none;
	.card-body {
		box-shadow: none;
		.inputs {
			width: 20%;
			height: 38px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
		}
		.text-area {
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			margin-top: 16px;
		}
		.upload-icons-btn {
			border: none;
			padding: 10px;
			background: #fff;
		}
		.preview-icon {
			max-width: 60px;
		}
		.upload-box {
			width: 100%;
			height: 200px;
			background: #f8f8f8;
			margin-top: 24px;
			border-radius: 8px;
			border: 2px dashed #2d8b8b;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			position: relative;
			.upload-text {
				color: #2d8b8b;
			}
			input {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				opacity: 0;
			}
			.icon {
				margin-bottom: 20px;
				.iconify {
					font-size: 40px;
					color: #404041cc;
				}
			}
			p {
				color: #404041;
			}
		}
		.button-container {
			display: flex;
			justify-content: flex-end;
			margin-top: 12px;
			.continue {
				border: none;
				background: #2d8b8b;
				padding: 8px;
				border-radius: 8px;
				color: #fff;
				margin-left: 8px;
				&:disabled {
					background: #f1f1f1;
					color: #535656;
					border-radius: 8px;
					border: none;
					padding: 8px;
				}
			}
		}
	}
}
</style>
